import { IShowDriveSelectorPanelArgs } from '@src/js/common/ark-extensions/dc-components/docs-component-drive-selector-panel/type';
import { AttachmentInfo } from '@src/slide/domain/ui-model/element-modeles/property/attachment/interface';
import { ServiceList, IDriveSelectorPanelService, IServiceDelegates, IShowArgs } from '../interface';

export abstract class BaseDriveSelectorPanelService implements IDriveSelectorPanelService {
    protected serviceList: ServiceList;
    private result: AttachmentInfo | null;
    private serviceDelegates: IServiceDelegates;

    public setServiceDelegates(serviceDelegates: IServiceDelegates) {
        this.serviceDelegates = serviceDelegates;
    }

    public get getSelectedResult() {
        return this.result;
    }

    private set setSelectedResult(result: AttachmentInfo) {
        this.result = result;
    }

    protected onResolve: IShowDriveSelectorPanelArgs['config']['onResolve'] = ([attachmentInfo, error]) => {
        if (error) {
            window?.log.error(error);
        } else {
            // attachmentInfo即为最终结果，可用于显示附件！
            window?.log.info('get result!!: ', attachmentInfo);

            this.setSelectedResult = attachmentInfo;

            // 服务处理
            this.serviceList.forEach((name) => {
                switch (name) {
                    // 附件服务
                    case 'attachmentManager':
                        this.serviceDelegates.attachmentManager.insertAttachmentDirectly([attachmentInfo]);
                        break;

                    default:
                        break;
                }
            });
        }
    };

    public abstract show({ serviceList, config }: IShowArgs): Promise<this>;
}
